import axios from "axios";
import store from '@/store'

const initialState = () => ({
  country: {
    "pais_id": "AR",
    "idioma_id": "es",
    "moneda_id": "ARS",
    "region_defecto_id": 3433955,
    "sucursal_defecto_id": 1,
    "nombre": "Argentina",
    "zona_horaria": "UTC-03:00",
    "multiplicador": 1,
    "descuento_global": 40,
    "default_timezone_id": "America/Argentina/Buenos_Aires",
    "moneda": {
      "moneda_id": "ARS",
      "nombre": "Peso Argentino"
    }
  },
  region: {
    "region_id": 3435907,
    "region_iso_id": "AR-B",
    "pais_id": "AR",
    "nombre": "Buenos Aires",
    "latitud": -36,
    "longitud": -60
  },
  userCalendars: [],
  userCalendarsGrouped: [],
  teacherGrouped: []
});

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    SET_TEACHER_GROUPED(state, payload) {
      state.teacherGrouped = payload;
    },
    SET_USER_CALENDARS_GROUPED(state, payload) {
      state.userCalendarsGrouped = payload;
    },
    SET_USER_CALENDARS(state, payload) {
      state.userCalendars = payload;
    }
  },
  actions: {
    async fetch({ state }) {
      try{
        const response = await axios.get(process.env.VUE_APP_EDUCACIONIT_API_SERVER + "init?include=pais,region", {});

        state.country = response.data.pais;
        state.region = response.data.region;
      } catch(e){
        console.error(e);
      }
    },
    async fetchUserCalendars({ commit, rootState }) {
      const userId = parseInt(rootState.Auth.user.userId, 10);

      const token = await store.state.AuthFirebase.auth.currentUser?.getIdToken();

      const options = {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-Hollow-Man': localStorage.getItem('client_init_ts') ?? '',
          'Content-Type': 'application/json'
        }
      };

      const params = {
        contacto_id: userId,
        include: 'curso,clases,profesor,calendario_detalle',
        attributes: 'calendario_id,curso_id,pendiente,anulado,turno,discord_channel_id,discord_deleted_at,contactos_calendarios.paquete_id,contactos_calendarios.calendario_recursa_id,contactos_calendarios.paquete_calendario_id'
      };

      const getStart = (item) => {
        const date = item?.calendario_detalle?.fecha_inicio;
        return date ? Date.parse(date) : 0;
      };

      const sortByStartDesc = (a, b) => getStart(b) - getStart(a);

      const isTeacher = (item) => {
        return (
          userId === item.profesor?.contacto?.contacto_id ||
          item.calendarios_permisos?.some(
            (p) => p.rol_id === 39 && p.alumni_estado_id === 'A'
          )
        );
      };

      const hasActivePermission = (item) => {
        return item.calendarios_permisos?.some((p) => p.alumni_estado_id === 'A');
      };

      try {
        const calendarsRequest = axios.get(
          `${process.env.VUE_APP_EDUCACIONIT_API_SERVER}alumni/calendarios`,
          { ...options, params }
        );

        const statsRequest = axios
          .get(
            `${process.env.VUE_APP_EDUCACIONIT_API_SERVER}alumni/contactos/${userId}/exams/stats`,
            options
          )
          .then((response) => response.data?.data ?? [])
          .catch(() => []);

        const [calResponse, statsArray] = await Promise.all([
          calendarsRequest,
          statsRequest
        ]);

        const calendarsData = calResponse.data?.data ?? [];

        const statsByCursoId = new Map(
          statsArray
            .filter(({ curso_id }) => !!curso_id)
            .map(({ curso_id, total, approved }) => [
              curso_id,
              {
                total,
                approved,
                progress: total ? Math.round((approved / total) * 100) : 0
              }
            ])
        );

        const calendarsById = new Map(
          calendarsData.map((calendar) => [calendar.calendario_id, calendar])
        );

        const rawTeacherItems = calendarsData.filter(isTeacher);

        const teacherCounts = rawTeacherItems.reduce((acc, item) => {
          acc[item.curso_id] = (acc[item.curso_id] || 0) + 1;
          return acc;
        }, {});

        const teacherMap = new Map();
        const teacherList = [];
        const studentList = [];

        for (const item of calendarsData) {
          /*for (const cc of item.contactos_calendarios ?? []) {
            if (!cc.paquete_calendario_id) continue;

            const packageCalendar = calendarsById.get(cc.paquete_calendario_id);

            const packageBlocked = packageCalendar?.calendarios_permisos?.some(
              (p) => p.alumni_estado_id === 'B'
            );

            if (packageBlocked) {
              for (const permission of item.calendarios_permisos ?? []) {
                permission.alumni_estado_id = 'B';
              }
              break;
            }
          }*/

          const teacher = isTeacher(item);

          const calendar = {
            ...item,
            is_teacher: teacher,
            curso: {
              ...item.curso,
              stats: statsByCursoId.get(item.curso_id) || null
            }
          };

          if (teacher) {
            teacherList.push(calendar);

            const count = teacherCounts[item.curso_id] || 0;
            const shouldBeGrouped = !calendar.pendiente || count === 1;

            if (shouldBeGrouped) {
              const prev = teacherMap.get(item.curso_id);

              if (!prev || getStart(calendar) > getStart(prev)) {
                teacherMap.set(item.curso_id, calendar);
              }
            }
          } else if (hasActivePermission(item)) {
            studentList.push(calendar);
          }
        }

        const teacherGrouped = [...teacherMap.values()].sort(sortByStartDesc);
        const sortedStudents = [...studentList].sort(sortByStartDesc);
        const sortedTeachers = [...teacherList].sort(sortByStartDesc);

        const groupedCalendars = [...teacherGrouped, ...sortedStudents];
        const calendars = [...sortedTeachers, ...sortedStudents];

        commit('SET_TEACHER_GROUPED', teacherGrouped);
        commit('SET_USER_CALENDARS_GROUPED', groupedCalendars);
        commit('SET_USER_CALENDARS', calendars);

        return calendars;
      } catch (error) {
        if (error.response?.status === 404) {
          commit('SET_USER_CALENDARS', []);
          commit('SET_USER_CALENDARS_GROUPED', []);
          commit('SET_TEACHER_GROUPED', []);
          return error.response;
        }

        return error.response;
      }
    }
  },
  getters: {
    country: (state) => state.country,
    region: (state) => state.region,
    userCalendars: (state) => state.userCalendars,
    userCalendarsGrouped: (state) => state.userCalendarsGrouped,
    teacherGrouped: (state) => state.teacherGrouped
  },
};
